import React, { useMemo } from 'react';
import {
  EFabricationOrderStatus,
  fabricationOrderStatusMap
} from '../../../../../store/ducks/fabrication-orders/types';
import { Select } from '@gerdau/hefesto/Select';

interface IFabricationOrderStatusSelectProps {
  placeholder: string;
  disabled: boolean;
  selectedStatus: EFabricationOrderStatus[];
  onSelectedStatus(selectedStatus: EFabricationOrderStatus[]): void;
  availableStatusToFilter: EFabricationOrderStatus[];
}

const FabricationOrderStatusSelect: React.FC<
  IFabricationOrderStatusSelectProps
> = ({
  disabled,
  selectedStatus,
  onSelectedStatus,
  availableStatusToFilter
}) => {
  const fabricationOrdersStatusOptions = useMemo(
    () =>
      Object.values(EFabricationOrderStatus)
        .filter((status) => availableStatusToFilter.includes(status))
        .map((status) => {
          const label = fabricationOrderStatusMap
            .get(status as EFabricationOrderStatus)
            ?.toLowerCase()
            .split(' ')
            .join('-');

          return {
            label: label ?? '',
            value: status
          };
        }),
    [availableStatusToFilter]
  );

  return (
    <Select
      label="Status do pedido"
      name={'dropdownCustomers'}
      value={selectedStatus || []}
      options={fabricationOrdersStatusOptions}
      isMultipleSelect={true}
      disabled={disabled}
      onSelect={(value: string | string[]) => {
        onSelectedStatus(value as EFabricationOrderStatus[]);
      }}
    ></Select>
  );
};

export default FabricationOrderStatusSelect;
